// import axios from 'axios';
// import { useCallback } from 'react';
// import { useDispatch, useSelector, shallowEqual } from 'react-redux';
// import { API_REQUEST_URL } from '../../../common/apiConfig';
// import {
//   DASHBOARD_FETCH_SUMMARY_DATA_BEGIN,
//   DASHBOARD_FETCH_SUMMARY_DATA_SUCCESS,
//   DASHBOARD_FETCH_SUMMARY_DATA_FAILURE,
//   DASHBOARD_FETCH_SUMMARY_DATA_DISMISS_ERROR,
//   ERROR_CONTACT_ADMIN,
// } from './constants';

// const DASHBOARD_FETCH_SUMMARY_DATA_COMPLETE = 'DASHBOARD_FETCH_SUMMARY_DATA_COMPLETE';

// const SUMMARY_ENDPOINTS = {
//   salesCore: '/summary/salesCore',
//   exceptions: '/summary/exceptions',
//   trends: '/summary/trends',
// };

// const getErrorMessage = err => {
//   return err && err.response && err.response.data && err.response.data.message
//     ? err.response.data.message
//     : ERROR_CONTACT_ADMIN;
// };

// export function fetchSummaryData(args = {}) {
//   return (dispatch, getState) => {
//     // optionally you can have getState as the second argument
//     dispatch({
//       type: DASHBOARD_FETCH_SUMMARY_DATA_BEGIN,
//     });

//     const cognitoIdToken = getState().home.auth.cognitoIdToken;
//     const token = `Bearer ${cognitoIdToken}`;
//     const payload= {
//       ...args,
//       caseCount: 15,
//     };
//     const requestConfig = {
//       headers: {
//         Authorization: token,
//       },
//     };

//     const handleRequestError = err => {
//       dispatch({
//         type: DASHBOARD_FETCH_SUMMARY_DATA_FAILURE,
//         data: { error: getErrorMessage(err) },
//       });

//       return null;
//     };

//     const salesCoreRequest = axios
//       .post(`${API_REQUEST_URL}${SUMMARY_ENDPOINTS.salesCore}`, payload, requestConfig)
//       .then(res => {
//         const data = {
//           salesSummaryData: res.data.salesSummary,
//           orderStatusSummaryData: res.data.orderStatusSummary,
//           orderByTypeSummaryData: res.data.orderTypeSummary,
//           detailsCondition: res.data.condition || args,
//         };

//         dispatch({
//           type: DASHBOARD_FETCH_SUMMARY_DATA_SUCCESS,
//           data,
//         });

//         return data;
//       })
//       .catch(handleRequestError);

//     const exceptionsRequest = axios
//       .post(`${API_REQUEST_URL}${SUMMARY_ENDPOINTS.exceptions}`, payload, requestConfig)
//       .then(res => {
//         const data = {
//           exceptionsSummaryData: res.data.salesSummary,
//           detailsCondition: res.data.condition || args,
//         };

//         dispatch({
//           type: DASHBOARD_FETCH_SUMMARY_DATA_SUCCESS,
//           data,
//         });

//         return data;
//       })
//       .catch(handleRequestError);

//     const trendsRequest = axios
//       .post(`${API_REQUEST_URL}${SUMMARY_ENDPOINTS.trends}`, payload, requestConfig)
//       .then(res => {
//         const data = {
//           orderTrendSummaryData: res.data.orderTrendSummary,
//           salesTrendSummaryData: res.data.salesTrendSummary,
//           detailsCondition: res.data.condition || args,
//         };

//         dispatch({
//           type: DASHBOARD_FETCH_SUMMARY_DATA_SUCCESS,
//           data,
//         });

//         return data;
//       })
//       .catch(handleRequestError);

//     return Promise.all([salesCoreRequest, exceptionsRequest, trendsRequest]).then(results => {
//       dispatch({
//         type: DASHBOARD_FETCH_SUMMARY_DATA_COMPLETE,
//       });

//       return results;
//     });
//   };
// }

// export function dismissFetchSummaryDataError() {
//   return {
//     type: DASHBOARD_FETCH_SUMMARY_DATA_DISMISS_ERROR,
//   };
// }

// export function useFetchSummaryData() {
//   const dispatch = useDispatch();

//   const {
//     salesSummaryData,
//     exceptionsSummaryData,
//     orderTrendSummaryData,
//     salesTrendSummaryData,
//     orderStatusSummaryData,
//     orderByTypeSummaryData,
//     detailsCondition,
//     fetchSummaryDataPending,
//     fetchSummaryDataError,
//   } = useSelector(
//     state => ({
//       salesSummaryData: state.dashboard.salesSummaryData,
//       exceptionsSummaryData: state.dashboard.exceptionsSummaryData,
//       orderTrendSummaryData: state.dashboard.orderTrendSummaryData,
//       salesTrendSummaryData: state.dashboard.salesTrendSummaryData,
//       orderStatusSummaryData: state.dashboard.orderStatusSummaryData,
//       orderByTypeSummaryData: state.dashboard.orderByTypeSummaryData,
//       detailsCondition: state.dashboard.detailsCondition,
//       fetchSummaryDataPending: state.dashboard.fetchSummaryDataPending,
//       fetchSummaryDataError: state.dashboard.fetchSummaryDataError,
//     }),
//     shallowEqual,
//   );

//   const boundAction = useCallback(
//     (...args) => {
//       return dispatch(fetchSummaryData(...args));
//     },
//     [dispatch],
//   );

//   const boundDismissError = useCallback(() => {
//     return dispatch(dismissFetchSummaryDataError());
//   }, [dispatch]);

//   return {
//     salesSummaryData,
//     exceptionsSummaryData,
//     orderTrendSummaryData,
//     salesTrendSummaryData,
//     orderStatusSummaryData,
//     orderByTypeSummaryData,
//     detailsCondition,
//     fetchSummaryData: boundAction,
//     fetchSummaryDataPending,
//     fetchSummaryDataError,
//     dismissFetchSummaryDataError: boundDismissError,
//   };
// }

// export function reducer(state, action) {
//   switch (action.type) {
//     case DASHBOARD_FETCH_SUMMARY_DATA_BEGIN:
//       // Just after a request is sent
//       return {
//         ...state,
//         fetchSummaryDataPending: true,
//         fetchSummaryDataError: null,
//       };

//     case DASHBOARD_FETCH_SUMMARY_DATA_SUCCESS:
//       // The request is success
//       return {
//         ...state,
//         salesSummaryData: action.data.salesSummaryData
//           ? { ...state.salesSummaryData, ...action.data.salesSummaryData }
//           : state.salesSummaryData,
//         exceptionsSummaryData: action.data.exceptionsSummaryData
//           ? { ...state.exceptionsSummaryData, ...action.data.exceptionsSummaryData }
//           : state.exceptionsSummaryData,
//         orderStatusSummaryData: action.data.orderStatusSummaryData || state.orderStatusSummaryData,
//         orderTrendSummaryData: action.data.orderTrendSummaryData || state.orderTrendSummaryData,
//         salesTrendSummaryData: action.data.salesTrendSummaryData || state.salesTrendSummaryData,
//         orderByTypeSummaryData: action.data.orderByTypeSummaryData || state.orderByTypeSummaryData,
//         detailsCondition: action.data.detailsCondition || state.detailsCondition,
//       };

//     case DASHBOARD_FETCH_SUMMARY_DATA_FAILURE:
//       // The request is failed
//       return {
//         ...state,
//         fetchSummaryDataError: action.data.error,
//       };

//     case DASHBOARD_FETCH_SUMMARY_DATA_COMPLETE:
//       return {
//         ...state,
//         fetchSummaryDataPending: false,
//       };

//     case DASHBOARD_FETCH_SUMMARY_DATA_DISMISS_ERROR:
//       // Dismiss the request failure error
//       return {
//         ...state,
//         fetchSummaryDataError: null,
//       };

//     default:
//       return state;
//   }
// }



import axios from 'axios';
import { useCallback } from 'react';
import { useDispatch, useSelector, shallowEqual } from 'react-redux';
import { API_REQUEST_URL } from '../../../common/apiConfig';
import {
  DASHBOARD_FETCH_SUMMARY_DATA_BEGIN,
  DASHBOARD_FETCH_SUMMARY_DATA_SUCCESS,
  DASHBOARD_FETCH_SUMMARY_DATA_FAILURE,
  DASHBOARD_FETCH_SUMMARY_DATA_DISMISS_ERROR,
  ERROR_CONTACT_ADMIN,
} from './constants';

const DASHBOARD_FETCH_SUMMARY_DATA_COMPLETE = 'DASHBOARD_FETCH_SUMMARY_DATA_COMPLETE';

const SUMMARY_ENDPOINTS = {
  salesCore: '/summary/salesCore',
  exceptions: '/summary/exceptions',
  trends: '/summary/trends',
};

const EMPTY_SALES_SUMMARY_DATA = {
  totalAllocatedCases: null,
  totalAllocatedEaches: null,
  totalCases: null,
  totalEaches: null,
  totalExceptions: null,
  totalGPPercentage: null,
  totalLines: null,
  totalOrders: null,
  totalPickPieces: null,
  totalPickups: null,
  totalSales: null,
  estimatedScGp: null,
};

const EMPTY_EXCEPTIONS_SUMMARY_DATA = {
  totalExceptions: null,
  exactExceptions: null,
  subsExceptions: null,
  offDay: null,
  afterCutOff: null,
  underMin: null,
};

const EMPTY_ORDER_STATUS_SUMMARY_DATA = {
  cancelled: null,
  creditHold: null,
  labelled: null,
  lockedOrErrored: null,
  merchHold: null,
  open: null,
  pendingApproval: null,
  routing: null,
  shippedOrInvoiced: null,
};

const EMPTY_ORDER_BY_TYPE_SUMMARY_DATA = {
  dropShip: null,
  hotShot: null,
  regular: null,
  willCall: null,
  unconfirmed: null,
};

const createEmptySummaryState = () => ({
  salesSummaryData: { ...EMPTY_SALES_SUMMARY_DATA },
  exceptionsSummaryData: { ...EMPTY_EXCEPTIONS_SUMMARY_DATA },
  detailsCondition: null,
  orderStatusSummaryData: { ...EMPTY_ORDER_STATUS_SUMMARY_DATA },
  orderTrendSummaryData: [],
  salesTrendSummaryData: [],
  orderByTypeSummaryData: { ...EMPTY_ORDER_BY_TYPE_SUMMARY_DATA },
});

const createSummarySuccessPayload = args => ({
  salesSummaryData: { ...EMPTY_SALES_SUMMARY_DATA },
  exceptionsSummaryData: { ...EMPTY_EXCEPTIONS_SUMMARY_DATA },
  detailsCondition: args,
  orderStatusSummaryData: { ...EMPTY_ORDER_STATUS_SUMMARY_DATA },
  orderTrendSummaryData: [],
  salesTrendSummaryData: [],
  orderByTypeSummaryData: { ...EMPTY_ORDER_BY_TYPE_SUMMARY_DATA },
});

const getErrorMessage = err => {
  return err && err.response && err.response.data && err.response.data.message
    ? err.response.data.message
    : ERROR_CONTACT_ADMIN;
};

export function fetchSummaryData(args = {}) {
  return (dispatch, getState) => {
    dispatch({
      type: DASHBOARD_FETCH_SUMMARY_DATA_BEGIN,
    });

    const cognitoIdToken = getState().home.auth.cognitoIdToken;
    const token = `Bearer ${cognitoIdToken}`;
    const payload = {
      ...args,
      caseCount: 15,
    };
    const requestConfig = {
      headers: {
        Authorization: token,
      },
    };

    const salesCoreRequest = axios.post(
      `${API_REQUEST_URL}${SUMMARY_ENDPOINTS.salesCore}`,
      payload,
      requestConfig,
    );

    const exceptionsRequest = axios.post(
      `${API_REQUEST_URL}${SUMMARY_ENDPOINTS.exceptions}`,
      payload,
      requestConfig,
    );

    const trendsRequest = axios.post(
      `${API_REQUEST_URL}${SUMMARY_ENDPOINTS.trends}`,
      payload,
      requestConfig,
    );

    return Promise.allSettled([salesCoreRequest, exceptionsRequest, trendsRequest])
      .then(([salesCoreResult, exceptionsResult, trendsResult]) => {
        const data = createSummarySuccessPayload(args);

        let firstError = null;
        let hasAnySuccess = false;

        if (salesCoreResult.status === 'fulfilled') {
          hasAnySuccess = true;
          data.salesSummaryData = salesCoreResult.value.data.salesSummary || { ...EMPTY_SALES_SUMMARY_DATA };
          data.orderStatusSummaryData =
            salesCoreResult.value.data.orderStatusSummary || { ...EMPTY_ORDER_STATUS_SUMMARY_DATA };
          data.orderByTypeSummaryData =
            salesCoreResult.value.data.orderTypeSummary || { ...EMPTY_ORDER_BY_TYPE_SUMMARY_DATA };
          data.detailsCondition = salesCoreResult.value.data.condition || data.detailsCondition;
        } else {
          firstError = firstError || getErrorMessage(salesCoreResult.reason);
        }

        if (exceptionsResult.status === 'fulfilled') {
          hasAnySuccess = true;
          data.exceptionsSummaryData =
            exceptionsResult.value.data.salesSummary || { ...EMPTY_EXCEPTIONS_SUMMARY_DATA };
          data.detailsCondition = exceptionsResult.value.data.condition || data.detailsCondition;
        } else {
          firstError = firstError || getErrorMessage(exceptionsResult.reason);
        }

        if (trendsResult.status === 'fulfilled') {
          hasAnySuccess = true;
          data.orderTrendSummaryData = trendsResult.value.data.orderTrendSummary || [];
          data.salesTrendSummaryData = trendsResult.value.data.salesTrendSummary || [];
          data.detailsCondition = trendsResult.value.data.condition || data.detailsCondition;
        } else {
          firstError = firstError || getErrorMessage(trendsResult.reason);
        }

        if (hasAnySuccess) {
          dispatch({
            type: DASHBOARD_FETCH_SUMMARY_DATA_SUCCESS,
            data,
          });
        } else {
          dispatch({
            type: DASHBOARD_FETCH_SUMMARY_DATA_FAILURE,
            data: { error: firstError || ERROR_CONTACT_ADMIN },
          });
        }

        dispatch({
          type: DASHBOARD_FETCH_SUMMARY_DATA_COMPLETE,
        });

        return [salesCoreResult, exceptionsResult, trendsResult];
      })
      .catch(err => {
        dispatch({
          type: DASHBOARD_FETCH_SUMMARY_DATA_FAILURE,
          data: { error: getErrorMessage(err) },
        });

        dispatch({
          type: DASHBOARD_FETCH_SUMMARY_DATA_COMPLETE,
        });

        throw err;
      });
  };
}

export function dismissFetchSummaryDataError() {
  return {
    type: DASHBOARD_FETCH_SUMMARY_DATA_DISMISS_ERROR,
  };
}

export function useFetchSummaryData() {
  const dispatch = useDispatch();

  const {
    salesSummaryData,
    exceptionsSummaryData,
    orderTrendSummaryData,
    salesTrendSummaryData,
    orderStatusSummaryData,
    orderByTypeSummaryData,
    detailsCondition,
    fetchSummaryDataPending,
    fetchSummaryDataError,
  } = useSelector(
    state => ({
      salesSummaryData: state.dashboard.salesSummaryData,
      exceptionsSummaryData: state.dashboard.exceptionsSummaryData,
      orderTrendSummaryData: state.dashboard.orderTrendSummaryData,
      salesTrendSummaryData: state.dashboard.salesTrendSummaryData,
      orderStatusSummaryData: state.dashboard.orderStatusSummaryData,
      orderByTypeSummaryData: state.dashboard.orderByTypeSummaryData,
      detailsCondition: state.dashboard.detailsCondition,
      fetchSummaryDataPending: state.dashboard.fetchSummaryDataPending,
      fetchSummaryDataError: state.dashboard.fetchSummaryDataError,
    }),
    shallowEqual,
  );

  const boundAction = useCallback(
    (...args) => {
      return dispatch(fetchSummaryData(...args));
    },
    [dispatch],
  );

  const boundDismissError = useCallback(() => {
    return dispatch(dismissFetchSummaryDataError());
  }, [dispatch]);

  return {
    salesSummaryData,
    exceptionsSummaryData,
    orderTrendSummaryData,
    salesTrendSummaryData,
    orderStatusSummaryData,
    orderByTypeSummaryData,
    detailsCondition,
    fetchSummaryData: boundAction,
    fetchSummaryDataPending,
    fetchSummaryDataError,
    dismissFetchSummaryDataError: boundDismissError,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case DASHBOARD_FETCH_SUMMARY_DATA_BEGIN:
      return {
        ...state,
        ...createEmptySummaryState(),
        fetchSummaryDataPending: true,
        fetchSummaryDataError: null,
      };

    case DASHBOARD_FETCH_SUMMARY_DATA_SUCCESS:
      return {
        ...state,
        salesSummaryData: action.data.salesSummaryData,
        exceptionsSummaryData: action.data.exceptionsSummaryData,
        orderStatusSummaryData: action.data.orderStatusSummaryData,
        orderTrendSummaryData: action.data.orderTrendSummaryData,
        salesTrendSummaryData: action.data.salesTrendSummaryData,
        orderByTypeSummaryData: action.data.orderByTypeSummaryData,
        detailsCondition: action.data.detailsCondition,
      };

    case DASHBOARD_FETCH_SUMMARY_DATA_FAILURE:
      return {
        ...state,
        fetchSummaryDataError: action.data.error,
      };

    case DASHBOARD_FETCH_SUMMARY_DATA_COMPLETE:
      return {
        ...state,
        fetchSummaryDataPending: false,
      };

    case DASHBOARD_FETCH_SUMMARY_DATA_DISMISS_ERROR:
      return {
        ...state,
        fetchSummaryDataError: null,
      };

    default:
      return state;
  }
}